@if (breakdown(); as b) {
  <div class="lot-prepa-summary flex-col gap-8">
    <!-- Titre + total -->
    <div class="flex-row gap-8 wrap align-center">
      <span class="caption on-background-alt">Ventilation stock</span>
      <div class="flex-grow"></div>
      <vl-help-tip
        title="Vue résumée"
        content="Le stock du lot est ventilé entre 4 catégories : stock principal (utilisable), engagé en zone prépa pour une commande, sur palette en cours de préparation, et historique expédié."
        formula="Total physique = Principal + Engagé + Palette">
        <span class="body-2">
          <strong>{{ b.quantiteTotale | number:'1.0-2' }}</strong>
          @if (unite()) {
            <span class="caption on-background-alt"> {{ unite() }}</span>
          }
          en stock
        </span>
      </vl-help-tip>
    </div>

    <!-- Barre segmentée -->
    <div class="bar">
      @if (pctExpedie() > 0) {
        <div class="seg expedie"
             [style.width.%]="pctExpedie()"
             [attr.title]="'Expédié : ' + (b.expedie | number:'1.0-2')"></div>
      }
      @if (pctPalette() > 0) {
        <div class="seg palette"
             [style.width.%]="pctPalette()"
             [attr.title]="'Sur palette : ' + (b.surPalette | number:'1.0-2')"></div>
      }
      @if (pctEngage() > 0) {
        <div class="seg engage"
             [style.width.%]="pctEngage()"
             [attr.title]="'Engagé en zone prépa : ' + (b.engagePrepa | number:'1.0-2')"></div>
      }
      @if (pctStock() > 0) {
        <div class="seg stock"
             [style.width.%]="pctStock()"
             [attr.title]="'Stock principal : ' + (b.stockPrincipal | number:'1.0-2')"></div>
      }
    </div>

    <!-- Légende compacte -->
    <div class="flex-row gap-12 wrap legend">
      <span class="legend-item stock">
        <span class="dot"></span>
        Principal <strong>{{ b.stockPrincipal | number:'1.0-2' }}</strong>
      </span>
      @if (b.engagePrepa > 0) {
        <span class="legend-item engage">
          <span class="dot"></span>
          Engagé <strong>{{ b.engagePrepa | number:'1.0-2' }}</strong>
          @if (b.parZonePrepa.length > 0) {
            <span class="caption on-background-alt">
              ({{ b.parZonePrepa.length }} CC)
            </span>
          }
        </span>
      }
      @if (b.surPalette > 0) {
        <span class="legend-item palette">
          <span class="dot"></span>
          Palette <strong>{{ b.surPalette | number:'1.0-2' }}</strong>
          @if (b.parPalette.length > 0) {
            <span class="caption on-background-alt">
              ({{ b.parPalette.length }})
            </span>
          }
        </span>
      }
      @if (b.expedie > 0) {
        <span class="legend-item expedie">
          <span class="dot"></span>
          Expédié <strong>{{ b.expedie | number:'1.0-2' }}</strong>
        </span>
      }
    </div>
  </div>
}
